/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as IndexRouteImport } from './routes/index'

const KontaktRoute = KontaktRouteImport.update({
  id: '/kontakt',
  path: '/kontakt',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/impressum': typeof ImpressumRoute
  '/kontakt': typeof KontaktRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/impressum': typeof ImpressumRoute
  '/kontakt': typeof KontaktRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/impressum': typeof ImpressumRoute
  '/kontakt': typeof KontaktRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/impressum' | '/kontakt'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/impressum' | '/kontakt'
  id: '__root__' | '/' | '/impressum' | '/kontakt'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ImpressumRoute: typeof ImpressumRoute
  KontaktRoute: typeof KontaktRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/kontakt': {
      id: '/kontakt'
      path: '/kontakt'
      fullPath: '/kontakt'
      preLoaderRoute: typeof KontaktRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ImpressumRoute: ImpressumRoute,
  KontaktRoute: KontaktRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
